import { SENS_VENTE, ETAT_BROUILLON } from '@/configuration/devisConf';
import { FACTURE_ETAT, FACTURE_SOUS_TYPE, SOUS_TYPE_ACOMPTE } from '@/configuration/facture/factureConf';

export default function genererCritereRecherche(page = 'FACTURE') {
  let critere = {
    clients: [],
    codeDossier: null,
    etat: [],
    type: [],
    tiersId: [],
    agencesId: [],
    commercialId: null,
    assistantIds: null,
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    montantHt: {
      montantMin: null,
      montantMax: null,
    },
    montantTtc: {
      montantMin: null,
      montantMax: null,
    },
    referenceIds: [],
    modesReglementsIds: [],
    groupeIds: [],
    enseigneIds: [],
    themes: [],
    categorieVente: [],
    interne: false,
    produitsIds: [],
    parutionsIds: [],
    planMediaIds: [],
    commandeIds: [],
    regleFacturationIds: [],
    sens: SENS_VENTE,
    factureParEmail: null,
    nePasRelancer: null,
    secteurIds: [],
    tagIds: [],
  };

  switch (page) {
    case 'TRANSMISSION':
      critere = {
        ...critere,
        etat: FACTURE_ETAT.filter((etat) => etat.code !== ETAT_BROUILLON),
        type: FACTURE_SOUS_TYPE.filter((etat) => etat.code !== SOUS_TYPE_ACOMPTE),
        tiersFactorIds: [],
        sansTiersFactorId: false,
        nonFactorisable: false,
        factorTransmis: false,
        factorDateTransmission: {
          dateDebut: null,
          dateFin: null,
        },
      };
      break;
    default:
      break;
  }

  return critere;
}
